
// easing functions
function psEase(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
}

function psEaseOut(t, b, c, d) {
    t /= d;
    return -c * t*(t-2) + b;
}

window.psEase = psEase;
window.psEaseOut = psEaseOut;

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-ps-scroll]').forEach(function(el) {
        el.addEventListener('click', function (e) {
            let psScroll = document.querySelector(this.getAttribute('data-ps-scroll'));

            if (psScroll) {
                e.preventDefault();

                let offset = parseInt(this.getAttribute('data-ps-offset')) || 0;
                let speed = parseInt(this.getAttribute('data-ps-speed')) || 500;
                let start = window.scrollY;
                let target = psScroll.getBoundingClientRect().top + start - offset;
                let distance = target - start;
                let time = null;
                console.log(speed);
                function animate(current) {
                    if (time === null) time = current;
                    let progress = current - time;
                    let run = psEase(progress, start, distance, speed);
                    window.scrollTo(0, run);

                    if (progress < speed) {
                        requestAnimationFrame(animate);
                    } else {
                        window.scrollTo(0, target);
                    }
                }

                requestAnimationFrame(animate);
            }
        });
    });
});
